// extracted by mini-css-extract-plugin
export default {"menu":"VerticalLayout_menu__t5Dt4","leftCol":"VerticalLayout_leftCol__bJx+z","btn":"VerticalLayout_btn__rmZJf"};